import React, { useEffect, useState } from 'react';
import { Modal, ModalHeader, ModalBody, Button, ModalFooter } from 'reactstrap';
import Select from 'react-select';
import { getJustificativa } from '../../../../services/DadoMestreService';

export default ({ items, isOpen, onClose, onSave }) => {
    const [justificativaOptions, setJustificativaOptions] = useState([]);

    const [justificativa, setJustificativa] = useState(null);

    const handleSave = () => {
        if (!justificativa) return;
        onSave(items, justificativa.value);
    };

    useEffect(() => {
        async function load() {
            const response = await getJustificativa();
            let options = [];
            if (response && response.length > 0) {
                response.forEach((x) => {
                    options.push({ value: x.justificativa, label: x.justificativa });
                });
            }

            setJustificativaOptions(options);
        }

        load();
    }, []);

    return (
        <Modal isOpen={isOpen} toggle={onClose}>
            <ModalHeader className='modal-title' style={{ position: 'relative', height: 50 }}>
                <span style={{ position: 'absolute', left: '41%' }}>Justificativas</span>
            </ModalHeader>
            <ModalBody>
                <Select
                    isRequired
                    isClearable
                    isSearchable
                    inputId='justificativa'
                    onChange={(e) => setJustificativa(e)}
                    value={justificativa}
                    options={justificativaOptions}
                    placeholder='Justificativa'
                />
            </ModalBody>
            <ModalFooter>
                <Button type='submit' size='md' color='primary' onClick={handleSave}>
                    Salvar
                </Button>
                <Button color='secondary' onClick={onClose}>
                    Cancelar
                </Button>
            </ModalFooter>
        </Modal>
    );
};
